import React from 'react';
import styled from 'styled-components';
import { Popover } from '@material-ui/core';
import {
  style,
  useAuthentication,
  useLikeTrack,
  useTrack,
} from '../../../../api';

import { TextBold14, TextRegular14, Text } from '../../Text';
import { HeartBorder, Heart } from '../../Icons';
import Box from '../../Box';

export default styled(
  ({
    trackId,
    className,
    iconOnly = false,
    size = 14,
  }: {
    trackId: number;
    className?: string;
    iconOnly?: boolean;
    size?: number;
  }) => {
    const [track] = useTrack(trackId);
    const { like, unlike } = useLikeTrack(trackId);
    const { isLoggedIn } = useAuthentication();
    const [anchorEl, setAnchorEl] = React.useState<EventTarget | null>(null);

    const open = Boolean(anchorEl) && !isLoggedIn;

    if (track === undefined) {
      return null;
    }

    if (track.logged_in_user_liked_track) {
      return (
        <Wrapper onClick={() => unlike()} className={className}>
          {!iconOnly && <LikedText>LIKED!</LikedText>}
          <Heart size={size} color={style.primary_pink_new} />
        </Wrapper>
      );
    }

    return (
      <Wrapper
        onClick={(event) => {
          if (isLoggedIn) {
            like();
          } else if (!anchorEl) {
            setAnchorEl(event.currentTarget);
          }
        }}
        className={className}
      >
        <Popover
          id="mouse-over-popover"
          open={open}
          anchorEl={anchorEl as Element}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {!iconOnly && <TextRegular14>LIKE</TextRegular14>}
          <Box backgroundColor={style.black} padding="8px">
            <Text color={style.white} fontSize="14px">
              Login to like this track
            </Text>
          </Box>
        </Popover>
        {!iconOnly && <LikeText>LIKE</LikeText>}
        <HeartBorder size={size} color={style.grey_dark_new} />
      </Wrapper>
    );
  },
)``;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    margin-left: 4px;
  }

  ${TextRegular14} {
    color: ${style.grey_dark_new};
  }
`;

const LikedText = styled(TextBold14)`
  color: ${style.primary_pink_new};
`;

const LikeText = styled(TextBold14)`
  color: ${style.grey_dark_new};
`;
